const DownCaret = props => {
    return (
        <svg className={props.className || ""} viewBox="0 -960 960 960"><path d="M480-345 240-585l43-43 197 198 197-197 43 43-240 239Z" /></svg>
    );
}
export default DownCaret;